module.exports = __webpack_public_path__ + "static/media/delete.3540af0e.svg";